import { db, getFromDB } from "../../firebase";
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

const keyCountries = "countries"

export const CountriesDB = {

  getAll: async () => {
    const countriesStored = localStorage.getItem(keyCountries)
      if (countriesStored === null) {
      try {
        const countriesCollectionRef = collection(db, 'countries');
        const countriesQuery = query(countriesCollectionRef, orderBy('name'));
        const snapshot = await getDocs(countriesQuery);
        const countriesData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        localStorage.setItem(keyCountries, JSON.stringify(countriesData))
        return countriesData;    
      } catch (error) {
        console.error('Error al obtener los datos de los paises:', error);
      }
    } else {
      return JSON.parse(countriesStored)
    }
  },

  getDistinct: async (distinctCountries) => {
    const tmpCountries = []
    const tmpCountryNames = []
    distinctCountries.forEach(countryName => {
      if (countryName !== '') {
        const country = localStorage.getItem(countryName)
        if (country !== null) {
          tmpCountries.push(JSON.parse(country))
          tmpCountryNames.push(countryName)
        }
      }
    })
    distinctCountries = distinctCountries.filter(value => !tmpCountryNames.includes(value) && value !== '');
    if (distinctCountries.length > 0) {
      try {
        const queryData = {table: 'countries', conditions: {field: 'name', operator: 'in', value: distinctCountries}}
        const dataResults = await getFromDB(queryData)
        if (dataResults !== undefined && dataResults.length > 0) {
          dataResults.forEach(country => {
            localStorage.setItem(country.name, JSON.stringify(country))
            tmpCountries.push(country)
          })
          return tmpCountries;
        }
      } catch (error) {
        console.error('Error al obtener los datos de los paises:', error);
      }
    } else {
      return tmpCountries
    }
  }
}